import template from './index.html.twig';
import './index.scss';

Shopware.Component.register('moorl-location-card', {
    template,
});
